import { getByDictKeyAndDictLabelParams } from '@/api/system/dictDetail'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(getByDictKeyAndDictLabelParams)
